import { Component, Injectable } from '@angular/core';
import swal from 'sweetalert2';
declare var $: any;

@Injectable({ providedIn: 'root' })
export class SweetAlertComponent {
    showSwal(type, mensaje) {
        if (type === 'success-message') {
            swal.fire({
                text: 'Operación exitosa',
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                icon: 'success'
            });
        } else if (type === 'error-message') {
            swal.fire({
                text: 'No se pudo completar la operación',
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                icon: 'error'
            });
        } else if (type === 'error-message-msg') {
            swal.fire({
                text: mensaje,
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                icon: 'error'
            });
        } else if (type === 'info-message') {
            swal.fire({
                text: 'Falta un campo requerido',
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                icon: 'info'
            });

        }
        else if (type === 'info-message2') {
            swal.fire({
                text: mensaje,
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                icon: 'info'
            });

        } else if (type === 'info-message-detail') {
            swal.fire({
                text: 'Formato inválido: ' + mensaje,
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                icon: 'info'
            });
        } else if (type === 'warning-message-and-confirmation') {
            swal.fire({
                text: mensaje,
                icon: 'warning',
                showCancelButton: true,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                buttonsStyling: false
            }).then((result) => {
                if (result.value) {
                    swal.fire({
                            text: 'Operación exitosa',
                            icon: 'success',
                            customClass:{
                                confirmButton: 'btn btn-success',
                                cancelButton: 'btn btn-danger',
                              },
                            buttonsStyling: false
                        }
                    );
                }
            });
        } else if (type === 'basic') {
            swal.fire({
                title: 'Respuesta exitosa',
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
            });

        }
        else if (type === 'warning-message-and-cancel') {
            swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to recover this imaginary file!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                buttonsStyling: false
            }).then((result) => {
                if (result.value) {
                    swal.fire({
                        title: 'Deleted!',
                        text: 'Your imaginary file has been deleted.',
                        icon: 'success',
                        customClass:{
                            confirmButton: 'btn btn-success',
                            cancelButton: 'btn btn-danger',
                          },
                        buttonsStyling: false
                    });
                } else {
                    swal.fire({
                        title: 'Cancelled',
                        text: 'Your imaginary file is safe :)',
                        icon: 'error',
                        customClass:{
                            confirmButton: 'btn btn-info',
                            cancelButton: 'btn btn-danger',
                          },
                        buttonsStyling: false
                    });
                }
            });

        } else if (type === 'custom-html') {
            swal.fire({
                title: 'HTML example',
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                html: 'You can use <b>bold text</b>, ' +
                    '<a href="http://github.com">links</a> ' +
                    'and other HTML tags'
            });

        } else if (type === 'auto-close') {
            swal.fire({
                title: 'Auto close alert!',
                text: 'I will close in 2 seconds.',
                timer: 2000,
                showConfirmButton: false
            });
        } else if (type === 'input-field') {
            swal.fire({
                title: 'Input something',
                html: '<div class="form-group">' +
                    '<input id="input-field" type="text" class="form-control" />' +
                    '</div>',
                showCancelButton: true,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                buttonsStyling: false
            }).then(function (result) {
                swal.fire({
                    icon: 'success',
                    html: 'You entered: <strong>' +
                        $('#input-field').val() +
                        '</strong>',
                        customClass:{
                            confirmButton: 'btn btn-success',
                            cancelButton: 'btn btn-danger',
                          },
                    buttonsStyling: false

                });
            });
        }else if (type === 'info-rule') {
            swal.fire({
                text: mensaje,
                buttonsStyling: false,
                customClass:{
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                  },
                confirmButtonText: 'Aceptar',
                icon: 'info'
            });

        }
    }
}
